module.exports = __webpack_public_path__ + "static/media/certyfikat-27.a2afc1ad.png";